// Shop-Texter: Säit Shop + Galerie « d’Spill an echt ».
// Iwwersetzung vu fr/shop.js — genee déiselwecht Schlësselen.
// D’Produkttexter (name, description, features vun de Packen) stinn hei NET:
// déi kommen aus der Datebank via tp()/tpList() (kuck LanguageContext).
export default {
  'shop.seo.titre': 'Shop - Gender-Reveal-Puzzlen',
  'shop.seo.description':
    "Zwee Joyful-Reveal-Packen, fir d'Geschlecht vum Bëbee mat der Famill z'entdecken. Liwwerung a Lëtzebuerg, an der Belsch, a Frankräich an an Däitschland.",

  'shop.page.chargement': 'De Shop gëtt gelueden...',

  // Strukturéiert Donnéeën schema.org (CollectionPage), an de <head> gesat.
  'shop.schema.nom': 'Mirum Games Shop',
  'shop.schema.description': 'Entdeckt all eis Joyful-Reveal-Packen',

  'shop.entete.badge': '🛍️ Eise Shop',
  'shop.entete.titre': 'Joyful Reveal - Bieren',
  'shop.entete.texte':
    'Wielt de Pack, deen zu Ärem magesche Moment passt. All Puzzle ass eng speziell Kreatioun fir Är Famill.',

  // Wielhëllef: de Saz ass a Segmenter opgedeelt, well « Essentiel » a
  // « Premium » an der JSX tëscht <strong> stinn. seg1+seg2+seg3+seg4+seg5 =
  // de ganze Saz; d’Espacen um Ufank an um Enn vun de Segmenter zielen mat.
  'shop.aide.titre': 'Zwee Packen, ee Spill',
  'shop.aide.seg1': 'Den ',
  'shop.aide.seg2': 'Essentiel',
  'shop.aide.seg3': ', wann Dir Är Froen an Är Equipen selwer virbereet. De ',
  'shop.aide.seg4': 'Premium',
  'shop.aide.seg5':
    ', wann Dir wëllt, datt alles scho prett ukënnt: d’Stoffsäckelcher, de gedréckte Froebou an d’Souvenir-Enveloppe.',

  // Réckgrëff fir d’Produiten: nëmme wann d’Datebank weder description nach
  // features liwwert (sollt net virkommen) — dat sinn keng packs.*-Schlësselen.
  'shop.produit.descriptionRepli':
    'Entdeckt dëse Joyful-Reveal-Pack fir eng onvergiesslech Gender Reveal Party!',
  'shop.produit.repliDuo1': '2 Spillschachtelen',
  'shop.produit.repliDuo2': 'Virdeelhafte Pack',
  'shop.produit.repliDuo3': 'Ideal fir 2 Feieren',
  'shop.produit.repliFamille1': '3 komplett Kits',
  'shop.produit.repliFamille2': 'Bescht Präis-Leeschtungs-Verhältnes',
  'shop.produit.repliFamille3': 'Ideal fir grouss Famillen',
  'shop.produit.repliPremium1': 'Komplett Spill',
  'shop.produit.repliPremium2': 'Accessoiren dobäi',
  'shop.produit.repliPremium3': 'Premium-Qualitéit',
  'shop.produit.repliMixte1': 'Versioun Meedchen + Jong',
  'shop.produit.repliMixte2': 'Ideal fir Zwillingen',
  'shop.produit.repliMixte3': 'Komplette Pack',
  'shop.produit.repliDefaut1': 'Gender-Reveal-Spillschachtel',
  'shop.produit.repliDefaut2': 'Handwierklech gemaach',
  'shop.produit.repliDefaut3': 'Séier Liwwerung',

  // Numm vum Artikel, sou wéi en an de Wuerekuerf kënnt.
  'shop.panier.nomArticle': 'Joyful Reveal - Bieren - {nom}',
  'shop.panier.suffixeGarcon': ' (Jong)',
  'shop.panier.suffixeFille': ' (Meedchen)',

  'shop.grille.altPhoto': '{nom} — Joyful Reveal, Gender-Reveal-Spill, Produktfoto',
  'shop.grille.rupture': '❌ AUSVERKAF',
  'shop.grille.bientotRetour': 'Geschwënn erëm do',
  'shop.grille.enStock': 'Um Lager',
  'shop.grille.voirPlus': 'Méi weisen',
  'shop.grille.autresCaracteristiques': '+{n} weiderer',
  'shop.grille.epuise': 'Ausverkaf',
  'shop.grille.ajoute': '✓ Bäigefüügt!',
  'shop.grille.ajouter': '🛒 Bäifügen',
  'shop.grille.versPanier': '→ Wuerekuerf',
  'shop.grille.ficheComplete': '📋 Déi komplett Produktsäit kucken',

  'shop.vide.titre': 'Kee Pack fonnt',
  'shop.vide.texte': 'Probéiert en anere Filter',

  'shop.pourquoi.titre': 'Firwat Joyful Reveal wielen?',
  'shop.pourquoi.emballageTitre': 'Premium-Verpakung',
  'shop.pourquoi.emballageTexte':
    'All Puzzle kënnt an enger elegante Kaddosverpakung, prett fir ze verschenken oder zesummen opzemaachen.',
  'shop.pourquoi.jeuTitre': 'Interaktivt Spill',
  'shop.pourquoi.jeuTexte':
    'En eenzegaartegt Konzept, dat aus der Uskënnegung e Spillmoment mécht, wou jiddereen matmécht, mat lëschtege Froen an Äntwerten.',
  'shop.pourquoi.assemblageTitre': 'Einfach zesummenzesetzen',
  'shop.pourquoi.assemblageTexte':
    'E Puzzle, deen Dir wärend dem Froen-an-Äntwerte-Spill ganz einfach a Famill zesummesetzt.',
  'shop.pourquoi.momentTitre': 'Magesche Moment',
  'shop.pourquoi.momentTexte':
    'Kreéiert eng onvergiesslech Erënnerung, andeems Dir d’Geschlecht vum Bëbee zesummen a Famill opdeckt.',
  'shop.pourquoi.expeditionTitre': 'Verschéckt aus der Belsch',
  'shop.pourquoi.expeditionTexte':
    'Ënnerwee bannent 1 bis 2 Aarbechtsdeeg a Richtung Belsch, Frankräich a Lëtzebuerg. Verstäerkte Verpakung.',
  'shop.pourquoi.retractationTitre': '14 Deeg fir Iech ëmzebesënnen',
  'shop.pourquoi.retractationTexte':
    'Dir kënnt d’Bestellung bannent 14 Deeg no Empfang widderruffen, sou wéi et d’europäescht Gesetz iwwer Online-Akeef virgesäit.',

  'shop.cta.titre': 'Prett fir déi magesch Uskënnegung?',
  'shop.cta.texte': 'Wielt Äre Pack a kreéiert en onvergiesslechte Moment mat Ärer Famill',
  'shop.cta.bouton': '🛒 D’Packen entdecken',

  'shop.modale.titre': 'Dat ass fir...',
  'shop.modale.sousTitre': 'Wielt d’Geschlecht fir Äre Puzzle',
  'shop.modale.garcon': 'Jong',
  'shop.modale.fille': 'Meedchen',
  'shop.modale.annuler': 'Ofbriechen',

  'shop.galerie.titre': 'D’Spill an echt',
  'shop.galerie.sousTitre':
    'Fotoen vum Produit, sou wéi Dir e kritt — keng béis Iwwerraschungen.',
  'shop.galerie.agrandir': 'Foto vergréisseren: {titre}',
  'shop.galerie.fermer': 'Zoumaachen',
  'shop.galerie.boiteRectoTitre': 'D’Schachtel',
  'shop.galerie.boiteRectoLegende': 'D’Spill Joyful Reveal, prett fir ze verschenken.',
  'shop.galerie.boiteRectoAlt':
    'Schachtel vum Spill Joyful Reveal: zwee Bieren, Puzzlestéck zum Rubbelen „GIRL oder BOY?“',
  'shop.galerie.contenuTitre': 'Wat Dir kritt',
  'shop.galerie.contenuLegende':
    'D’Schachtel, de Froebou als Souvenir an déi zwee Equipe-Stoffsäckelcher.',
  'shop.galerie.contenuAlt':
    'Kompletten Inhalt vum Spill Joyful Reveal: d’Schachtel, de Froebou als Souvenir an déi zwee Stoffsäckelcher',
  'shop.galerie.pochonsTitre': 'Déi zwou Equipen',
  'shop.galerie.pochonsLegende': 'Zwee Stoffsäckelcher fir Equipe 1 an Equipe 2.',
  'shop.galerie.pochonsAlt':
    'Déi zwee Stoffsäckelcher vum Spill, beschrëft mat Equipe 1 an Equipe 2, mat Bieren illustréiert',
  'shop.galerie.boiteVersoTitre': 'Wéi ee spillt',
  'shop.galerie.boiteVersoLegende': 'Déi 4 Etappe vum Spill, 2 bis 10 Spiller, ongeféier 20 Minutten.',
  'shop.galerie.boiteVersoAlt':
    'Récksäit vun der Joyful-Reveal-Schachtel mat den 4 Etappe vum Spill, fir 2 bis 10 Spiller, 20 Minutten',
};
